const ENDPOINTS = {
  onboardingChecklist: (storeId?: string) => `/api/onboarding-checklist?storeId=${storeId}`,
  onboardingChecklistManualOverride: (storeId?: string) =>
    `/api/onboarding-checklist/manual-override?storeId=${storeId}`,
};

export { ENDPOINTS };
